import React from "react";
import styled, {keyframes} from "styled-components";
import {useRecoilValue} from "recoil";
import {loadingPageState} from "../state";

// Animation keyframes
const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Styled component for the loading spinner
const LoadingSpinner = styled.div`
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 4px solid #1086e9;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${spinAnimation} 1s linear infinite;
`;

// Loading component
export const Loading = () => {
   const loadingPage = useRecoilValue(loadingPageState)
   return !!loadingPage ? (
      <div className="dtp-loading-screen">
         <LoadingSpinner className="upos-loading-img"/>
      </div>
   ) : <></>
};
